<template>
  <v-card outlined class="text-center pb-5">
    <v-card-text>
      <div class="title font-weight-regular text-left">{{ title }}</div>
      <div v-if="!!subtitle" class="subtitle-2 text-left">{{ subtitle }}</div>
      <div class="text-h3 text-left" :class="!!subtitle? 'mt-0' : 'mt-5'">
        <span class="display-1 font-weight-black" :class="[checkTitle ? 'red--text' : '']">
          {{ value }}
        </span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "StatInfoCard",
  props: {
    title: {
      type: String,
      default: "title"
    },
    subtitle: {
      type: String
    },
    value: {
      type: String,
      default: "value"
    }
  },
  computed : {
    checkTitle : function () {
      if(this.title == '미수금(원)') {
        return true
      } else return false
    }
  }
}
</script>

<style scoped>

</style>